
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/experience",
      function () {
        return require("private-next-pages/experience.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/experience"])
      });
    }
  